import { useRouter } from 'next/router'
import Select from '@components/select/Select'
import createRouterCallback from './functions/createRouterCallback'
import hideOnMobile from '@hoc/hideOnMobile'

const STATE_NAME = 'stan'
const STATE_OPTIONS = [
    { t: 'Nowy', value: 'Nowy' },
    { t: 'Używany', value: 'Uzywany' },
]

const State = () => {
    const router = useRouter()
    const onChange = createRouterCallback(router, STATE_NAME)

    return <Select
        name={STATE_NAME}
        label="Stan"
        options={STATE_OPTIONS}
        defaultOption={router.query[STATE_NAME]}
        onChange={onChange}
    />
}

export default hideOnMobile(State)